// Create a wrapper component that ensures the correct React instance
let ImportedComponentWrapper;
let CertificationsComponent,
  PureFlocCalculator,
  SystemSelectorWrapper,
  ImportedComponent,
  SystemSelector,
  CategorySelector;

if (typeof window !== "undefined") {
  CertificationsComponent =
    require("./certifications/certifications-component").default;
  PureFlocCalculator =
    require("./purefloc-calculator/purefloc-calculator.component").default;
  SystemSelectorWrapper =
    require("@headless/lib/system-selector/system-selector.component").SystemSelectorWrapper;
  CategorySelector =
    require("@selectionwizard/CategorySelector").default;

  // Create a wrapper that uses the global React instance
  const OriginalImportedComponent =
    require("./Hook/imported-component-wrapper").ImportedComponentWrapper;

  const OriginalSystemSelector =
    require("@headless/lib/system-selector/system-selector.component").SystemSelector;

  ImportedComponentWrapper = () => {
    // Use the global React instance explicitly
    const React = globalThis.React;
    const [isMobileView, setIsMobileView] = React.useState(false);

    return React.createElement(
      "div",
      null,
      React.createElement(
        "h3",
        null,
        "Imported Lib Component Rendered! (Wrapped)"
      )
    );
  };

  console.log('Adding stylesheet for Etex Bundle');
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = '/React19.Etex.Bundle.css';
  document.head.appendChild(link);
  console.log('Stylesheet for Etex Bundle added to head');

  // Also keep the original for testing
  ImportedComponent = OriginalImportedComponent;
  console.log("Loaded components in React19Source");

  SystemSelector = OriginalSystemSelector;
}

export default {
  CertificationsComponent,
  PureFlocCalculator,
  SystemSelector,
  CategorySelector,
};
